/**
 * サーバータイプ
 */
export var ServerTypes;

(function (ServerTypes) {
  /**
   * クラウド
   */
  ServerTypes[ServerTypes["Cloud"] = 0] = "Cloud";
  /**
   * オンプレミス
   */

  ServerTypes[ServerTypes["Onpremises"] = 1] = "Onpremises";
})(ServerTypes || (ServerTypes = {}));